(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yscookie-mode-indicator"] && !Shopify.designMode) return;
  try {
    (()=>{
function sync(){
const bar=document.querySelector('[data-ys-mode-indicator]');if(!bar)return;
const params=new URLSearchParams(location.search),path=location.pathname;
let mode=window.YSOrderMode?.get?.()||'shipping';
if(params.get('mode')==='shipping'||params.get('mode')==='pickup')mode=params.get('mode');
if(path.includes('/collections/'))mode=params.get('mode')==='pickup'?'pickup':'shipping';
if(path.endsWith('/pages/click-collect')||bar.dataset.pickupOnly==='true')mode='pickup';
if(bar.dataset.pageType==='cart')mode=window.YSOrderMode?.get?.()||mode;
if(bar.dataset.shippingOnly==='true')mode='shipping';
const pickup=mode==='pickup';
const words=bar.querySelector('template').content,word=key=>words.querySelector('[data-'+key+']').textContent;
bar.querySelector('[data-ys-mode-title]').textContent=word(mode+'-title');
bar.querySelector('[data-ys-mode-detail]').textContent=word(mode+'-detail');
bar.querySelector('.ys-mode-indicator__icon').textContent=pickup?'📍':'🚚';
const change=bar.querySelector('[data-ys-mode-change]');
change.href=pickup?'/collections/nos-cookies?mode=shipping':'/pages/click-collect';
change.setAttribute('aria-label',word(pickup?'to-shipping':'to-pickup'));
bar.dataset.mode=mode;
bar.hidden=!['product','collection','search','cart'].includes(bar.dataset.pageType)&&!path.endsWith('/pages/click-collect');
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();
document.addEventListener('ys:order-mode',sync);
document.addEventListener('shopify:section:load',sync);
window.addEventListener('pageshow',sync);
window.addEventListener('hashchange',sync);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yscookie-photo-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const thumb=event.target.closest('[data-yp-image-src]');
  if(!thumb)return;
  const gallery=thumb.closest('[data-yp-gallery]');
  const image=gallery?.querySelector('.yp-gallery-main');
  if(!image)return;
  image.srcset=thumb.dataset.ypImageSrcset;
  image.src=thumb.dataset.ypImageSrc;
  image.alt=thumb.dataset.ypImageAlt;
  image.width=Number(thumb.dataset.ypImageWidth);
  image.height=Number(thumb.dataset.ypImageHeight);
  gallery.querySelectorAll('[data-yp-image-src]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yscookie-product-plus"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ys-product-plus]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;
    const mode = button.dataset.ysPlusMode === 'pickup' ? 'pickup' : 'shipping';
    const url = new URL(button.dataset.ysPlusProductUrl, location.origin);
    url.searchParams.set('mode', mode);
    if (button.hasAttribute('data-ys-plus-choose')) {
      location.assign(url.pathname + url.search);
      return;
    }
    button.disabled = true;
    button.textContent = '…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.ysPlusVariant), quantity: 1, properties: { 'Mode de commande': mode === 'pickup' ? 'Click & Collect — 293 Avenue de Dunkerque, Lomme' : 'Livraison France' } }] })
      });
      if (!response.ok) throw new Error('Add failed');
      window.YSOrderMode?.set?.(mode);
      button.textContent = '✓';
      button.classList.add('is-added');
      window.YSAddedPopup?.();
      setTimeout(() => { button.textContent = '+';button.classList.remove('is-added'); }, 1200);
    } catch (error) {
      location.assign(url.pathname + url.search);
    } finally {
      button.disabled = false;
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yscookie-review-stickers"] && !Shopify.designMode) return;
  try {
    (() => {
  const watch=()=>{
    document.querySelectorAll('.ys-reviews:not([data-observed])').forEach(section=>{
      section.dataset.observed='true';
      if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){section.dataset.seen='true';observer.disconnect()}},{threshold:.18});
      observer.observe(section);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
  document.addEventListener('shopify:section:load',watch);
})();
  } catch(e) { console.error(e); }
})();

})();
